import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_URL } from '../util/constants/APP_URL';

import logo from '../assets/images/LOGO_ASG.png';

const Home = () => {

    const navigate = useNavigate()
    useEffect(() => {
        setTimeout(() => {
            navigate(APP_URL.AUTHENTICATION.REGISTER)
        }, 5000);
    }, [])

    return (
        <div className="width-full height-full flex justify-content-center align-items-center bg-color">
            <div className="flex justify-content-center align-items-center gap-7-5 flex-column">
                <img src={logo} alt="logo" style={{ width: '140px', height: '70px' }} />
                <p className="ft-EricssonGA628 text-light-black subtitle-home">PRESENTA</p>
            </div>
        </div>

    )
}

export default Home;